import React from "react";
import { Trans } from "@lingui/macro";
import ProductsFilter from "../../../components/ProductsFilter";
import ProductsGridAdapter from "../../../components/ProductsGrid/ProductsGridAdapter";

const ProductsSection = ({
  isMobile,
  isDesktop,
  dispatch,
  attraction,
  lang,
  defaultProductsGridProps,
  products,
  cityId,
  currency,
  attractionId,
  filters,
}) => {
  return (
    <div>
      <div className="Tickets__products-filter_title">
        <Trans>All self-guided activities</Trans>
      </div>
      {!!products.products?.length && (
        <>
          <ProductsFilter
            isMobile={isMobile}
            isDesktop={isDesktop}
            dispatch={dispatch}
            attraction={attraction}
            lang={lang}
          />
          <ProductsGridAdapter
            {...defaultProductsGridProps}
            products={products.products}
            queryData={{
              loading: products.loading || false,
              current: products.current || 1,
              next: products.next,
              count: products.count || 0,
              pages: products.pages || 1,
            }}
            selectParams={{
              cityId,
              currency,
              attractionId,
              ...filters,
              lang: filters?.lang?.length ? filters.lang : lang,
            }}
            limitDisplay={false}
          />
        </>
      )}
    </div>
  );
};

export default ProductsSection;
